import DataTable from 'datatables.net-zf';
import 'datatables.net-responsive-zf';
import 'datatables.net-buttons-zf';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-buttons/js/buttons.print.mjs';
import jQuery from 'jquery';

DataTable.use(Foundation);

(function ($) {
    const $table = $('.print-schedule-table');
    if (!$table.length) return;
    const table = new DataTable($table[0], {
        responsive: true,
        stateSave: false,
        paging: false,
        fixedHeader: true,
        order: [],
        info: false,
        columnDefs: [
            { searchable: false, targets: [3, 4, 5, 6, 7, 8] }
        ],
        stripeClasses: [],
        layout: {
            topStart: {
                buttons: [
                    {
                        extend: 'print',
                        className: 'fi-print print-schedule-button',
                        text: 'Print'
                    }
                ]
            }
        }
    });
    table.draw();
})(jQuery);